<template>
    <ReferrerLayout :racingstars="$page.props.racingstars" :user="$page.props.user">
        <div class="bg-no-repeat bg-contain h-full">
            <div class="pt-12 pb-8 mx-auto max-w-7xl" >
                <div>
                    <div class="px-4 sm:px-6  md:mx-auto lg:flex text-center">
                        <div class="max-w-5xl mx-auto">
                            <ApplicationLogo class="h-20 w-full mb-14 mx-auto" />
                            <div class="mb-3">
                                <div class="md:flex flex-col hidden md:flex-row items-center justify-center">
                                    <img :src="asset('images/referrals/rs1.png')" alt="" class="w-full md:w-80 md:mr-4 mb-14">
                                    <img :src="asset('images/referrals/rs3.png')" alt="" class="w-full md:w-96 md:mr-4 mb-14">
                                    <img :src="asset('images/referrals/rs2.png')" alt="" class="w-full md:w-80 mb-14">
                                </div>
                                <div class="md:hidden">
                                    <carousel :items-to-show="1" :autoplay="6000" :wrap-around="true">
                                        <slide v-for="slide in 3" :key="slide">
                                            <a :href="route('dashboard')"><img v-bind:src="asset('images/referrals/rs' + slide +'.png')" alt=""></a>
                                        </slide>
                                    </carousel>
                                </div>
                            </div>
                                <a href="#signup" class="yellow-button mb-8 mx-8 px-8">Sign Up Now</a>

                            <p class="mt-10 text-base text-gray-300 sm:mt-5 text-2xl font-bold mb-14 px-8">
                                UK residents aged 18+, join today and get 50 FREE tokens
                            </p>

                            <h2 class="text-4xl leading-10 font-bold px-8 text-white mb-8">
                                How does it work?
                            </h2>
                            <p class="mt-10 text-base text-gray-300 sm:mt-5 sm:text-xl lg:text-lg xl:text-xl mb-8 px-8">
                                At Racing Stars we wanted to create a more interesting and accessible way for players to win cash prizes even if they know very little about horse racing.. Simply pick a meeting (a place where horses are racing) and choose 1 horse from each race that day. Once you’ve confirmed your horses you bet 10 of your free tokens to enter then sit back and relax. Once the race is finished you get your points awarded.
                            </p>

                            <img :src="asset('images/referrals/2.png')" alt="" class="mb-8">
                            <h2 class="text-4xl leading-10 font-bold px-8 text-white">
                                Points mean prizes
                            </h2>
                            <p class="mt-10 text-base text-gray-300 sm:mt-5 sm:text-xl lg:text-lg xl:text-xl px-8">
                                So how do we calculate the points?
                                <br>
                                <br>
                                We take the number of runners in a race, which decides which placed positions receive points, then take the odds of a placed runner and use the position multiplier to apply points.
                                <br>
                                <br>
                                For example, a race with 4 runners would calculate points for the 1st position only, taking a winning runner with the odds 10/1 you’d get 10/1 x 5 = 50 points!
                            </p>
                            <div class="px-8">
                                <table class="mt-10 text-base text-gray-300 sm:mt-5 sm:text-xl lg:text-lg xl:text-xl px-8 table-fixed w-full rounded bg-gray-800">
                                    <thead class="border-b border-gray-400 rounded" style="background-color: #111827">
                                    <td class="pl-4 py-2">NO. OF RUNNERS</td>
                                    <td class="pl-4 py-2">PLACES ALLOCATED POINTS</td></thead>
                                    <tbody>
                                    <tr class="border-b border-gray-400 ml-4 my-2">
                                        <td class="pl-6 py-3">1 - 4</td>
                                        <td class="pl-6 py-3"> 1st Only</td>
                                    </tr>
                                    <tr class="border-b border-gray-400 ml-4 my-2">
                                        <td class="pl-6 py-3">5 - 7</td>
                                        <td class="pl-6 py-3">1st & 2nd</td>
                                    </tr>
                                    <tr class="border-b border-gray-400 ml-4 my-2">
                                        <td class="pl-6 py-3">8 - 12</td>
                                        <td class="pl-6 py-3">1st, 2nd & 3rd</td>
                                    </tr>
                                    <tr>
                                        <td class="pl-6 py-3">13+</td>
                                        <td class="pl-6 py-3">1st, 2nd, 3rd & 4th</td>
                                    </tr>
                                    </tbody>
                                </table>
                                <table class="mt-10 text-base text-gray-300 sm:mt-5 sm:text-xl lg:text-lg xl:text-xl px-8 table-fixed w-full rounded bg-gray-800" >
                                    <thead class="border-b border-gray-400 rounded" style="background-color: #111827">
                                    <td class="pl-4 py-2">FINISHING POSTION</td>
                                    <td class="pl-4 py-2">MULTIPLIER</td></thead>
                                    <tbody>
                                    <tr class="border-b border-gray-400 ml-4 my-2">
                                        <td class="pl-6 py-3">1st</td>
                                        <td class="pl-6 py-3">x5</td>
                                    </tr>
                                    <tr class="border-b border-gray-400 ml-4 my-2">
                                        <td class="pl-6 py-3">2nd</td>
                                        <td class="pl-6 py-3">x3</td>
                                    </tr>
                                    <tr class="border-b border-gray-400 ml-4 my-2">
                                        <td class="pl-6 py-3">3rd</td>
                                        <td class="pl-6 py-3">x2</td>
                                    </tr>
                                    <tr>
                                        <td class="pl-6 py-3">4th</td>
                                        <td class="pl-6 py-3">x1</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>

                            <p class="mt-10 text-base text-gray-300 sm:mt-5 sm:text-xl lg:text-lg xl:text-xl px-8">
                                At the end of the meeting, all the points are tallied up and the leaderboard is finalised. Of all the players that entered, whoever finishes first gets the jackpot prize.
                                <br>
                                <br>
                                Due to the innovative way Racing Stars works with it’s point system, the favourite horse isn’t always the best way to win. So picking the horse with your favourite name might work out better than pick those in form.
                            </p>
                            <p class="border border-racing-stars-yellow rounded font-bold p-10 bg-gray-900 text-gray-300 m-10 text-xl flex">
                                <ExclamationCircleIcon  class="sm:block hidden h-14 w-14 mr-3 text-racing-stars-yellow"/>
                                Don’t forget, you can get 50 free points, just for signing up today, which means 5 free bets and 5 chances to win £50!
                            </p>
                            <a href="#signup" class="yellow-button mb-8 mx-8 px-8">Sign Up</a>
                            <h2 class="text-4xl leading-10 font-bold px-8 text-white">Beat your friends</h2>
                            <p class="mt-10 text-base text-gray-300 sm:mt-5 sm:text-xl lg:text-lg xl:text-xl mb-8 px-8">
                                To add to the fun you can create your own mini league to run with your friends and family. Simply create the league and add your friends so they can join in the fun. Keep track of who’s in the lead each day each day and find out who the overall winner is every Sunday.
                                <br>
                                <br>
                                There’s no prizes for the mini league so far (watch this space) but there’s never really a better feeling than beating your mates each week is there?
                            </p>
                            <img :src="asset('images/referrals/3.png')" alt="" class="mb-8">
                            <h2 class="text-4xl leading-10 font-bold px-8 text-white">How to play for free:</h2>
                            <p class="mt-10 text-base text-gray-300 sm:mt-5 sm:text-xl lg:text-lg xl:text-xl px-8">
                                To use your free tokens follow these simple steps:
                                <br>
                            </p>
                            <ul class="mt-10 text-base text-gray-300 sm:mt-5 sm:text-xl lg:text-lg xl:text-xl mb-8 list-disc list-inside px-8">
                                <li>Sign up to Racing stars on the form below</li>
                                <li>Pick a race meet for today</li>
                                <li>Select a horse from each race</li>
                                <li>Confirm your bet with 10 of your free tokens</li>
                                <li>Leaderboards updated throughout the day</li>
                                <li>Jackpots are automatically added to your cash balance and available to withdraw</li>
                            </ul>
                            <div class="mt-14 lg:col-span-12 lg:flex lg:items-center">
                                <div class="bg-white sm:max-w-md sm:w-full sm:mx-auto sm:rounded-lg">
                                    <div class="px-4 py-8 sm:px-10">
                                        <div class="md:mt-6" v-if="!registerFormVisible">
                                            <form action="#" method="POST" class="space-y-6">
                                                <div>
                                                    <label for="email" class="sr-only">Email</label>
                                                    <input v-model="form.email" type="text" name="email" id="email" autocomplete="email" placeholder="Enter your email address" required="" class="block w-full shadow-sm focus:ring-racing-stars-yellow focus:border-racing-stars-yellow sm:text-sm border-gray-300 rounded-md" />
                                                </div>
                                                <div>
                                                    <button type="button" @click="showRegisterForm()" class="font-semibold w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-black bg-racing-stars-yellow hover:bg-yellow-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-racing-stars-yellow" :disabled="!form.email" :class="{ 'opacity-25 cursor-not-allowed': !form.email }">
                                                        Create Your Account
                                                    </button>
                                                    <Link :href="route('login')" as="button" class="lg:hidden mt-4 font-semibold w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-black bg-racing-stars-yellow hover:bg-yellow-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-racing-stars-yellow">
                                                        Login
                                                    </Link>
                                                </div>
                                            </form>
                                        </div>
                                        <div v-else class="mt-6">
                                            <RegisterForm :ignore-dark-mode="true" :email="form.email"/>
                                        </div>
                                    </div>
                                    <div class="px-4 py-6 bg-gray-50 border-t-2 border-gray-200 sm:px-10 rounded-b" id="signup">
                                        <p class="text-xs leading-5 text-gray-500">By signing up, you agree to our <Link :href="route('terms')" class="font-medium text-gray-900 hover:underline">Terms</Link> &amp; <Link :href="route('privacy')" class="font-medium text-gray-900 hover:underline">Privacy Policy</Link>.</p>
                                    </div>
                                </div>
                            </div>
                            <h2 class="text-4xl leading-10 font-bold px-8 text-white mt-10">How to get an addtional 50 tokens</h2>
                            <p class="mt-10 text-base text-gray-300 sm:mt-5 sm:text-xl lg:text-lg xl:text-xl px-8">
                                Not only can you beat your friends in a mini league they can help you get more tokens! Simply refer a new friend to join Racing Stars with your own referral code, and you can both get  50 free tokens to play on what ever races you want.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </ReferrerLayout>
</template>
<script>
import { ref, computed } from 'vue'
import { ExclamationCircleIcon } from '@heroicons/vue/outline'
import GamblingCommissionLogo from '@/Jetstream/GamblingCommissionLogo'
import { Head, Link, usePage } from '@inertiajs/inertia-vue3';
import WebLayout from '@/Layouts/WebLayout.vue'
import RegisterForm from '@/Pages/Auth/Register.vue'
import Jackpots from '@/Pages/Home/Partials/Jackpots.vue'
import Tokens from '@/Pages/Home/Partials/Tokens.vue'
import Horses from '@/Pages/Home/Partials/Horses.vue'
import Bet from '@/Pages/Home/Partials/Bet.vue'
import Change from '@/Pages/Home/Partials/Change.vue'
import Points from '@/Pages/Home/Partials/Points.vue'
import Cta from '@/Pages/Home/Partials/CTA.vue'
import Faqs from '@/Pages/Home/Partials/FAQS.vue'
import FooterCta from '@/Pages/Home/Partials/FooterCTA.vue'
import { useForm } from '@inertiajs/inertia-vue3'
import ReferrerLayout from '@/Layouts/ReferrerLayout';
import ApplicationLogo from '@/Jetstream/ApplicationLogo'
import 'vue3-carousel/dist/carousel.css';
import { Carousel, Slide, Pagination, Navigation } from 'vue3-carousel';


export default {
    props: {
        nextRaceStartTime: String,
    },
    components: {
        ReferrerLayout,
        GamblingCommissionLogo,
        Link,
        WebLayout,
        RegisterForm,
        Jackpots,
        Tokens,
        Horses,
        Bet,
        Change,
        Points,
        Cta,
        Faqs,
        FooterCta,
        ApplicationLogo,
        ExclamationCircleIcon,
        Carousel,
        Slide,
        Pagination,
        Navigation,
    },
    setup(props) {
        const currentRoute = route().current()
        const page = usePage()
        const registerFormVisible = ref(false)
        const form = useForm({
            email: ''
        })
        const showRegisterForm = () => {
            registerFormVisible.value = true
        }
        const accountCreationEnabled = computed(() => {
            if (page.props.value.user) {
                return false
            }
            return true
        })
        return {
            form,
            accountCreationEnabled,
            registerFormVisible,
            showRegisterForm,
            page,
            currentRoute
        }
    }
}
</script>
